import { responseError } from '@/utils/errors';
import { assignProps, mapResults, selectableResult } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import { addFieldsToSections } from '../../helper';
import initialState from '../../state/state';
import {
  findCatalogueTemplate,
  findCatalogueTemplates,
  openCatalogueTemplate,
} from './state';
import actions from '../constants';

const closeCatalogueTemplates = withDraft((draft, { category }) => {
  draft.templates[category] = initialState.templates[category];
});

const fetchCatalogueTemplates = withDraft((draft, action) => {
  const item = findCatalogueTemplates(draft, action);
  item.readStatus = states.PENDING;
  item.readErrors = [];
});

const showCatalogueTemplates = withDraft((draft, action) => {
  const item = findCatalogueTemplates(draft, action);
  item.readStatus = states.SUCCESS;
  item.readErrors = [];
  item.results = action.append
    ? mapResults(item.results, action, selectableResult)
    : mapResults([], action, selectableResult);
  item.pageSize = action.pageSize;
  item.count = action.resultsCount;
  item.currentPage = action.currentPage;
  item.totalPages = action.totalPages;
});

const showCatalogueTemplatesError = withDraft((draft, action) => {
  const item = findCatalogueTemplates(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const fetchCatalogueTemplate = withDraft((draft, { category, code }) => {
  const item = findCatalogueTemplate(draft, { category, code });
  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.templates[category].results.push(openCatalogueTemplate({ code }));
  }
});

const showCatalogueTemplateSuccess = withDraft((draft, {
  category,
  code,
  result,
  intl,
}) => {
  const item = findCatalogueTemplate(draft, { category, code });
  const sections = addFieldsToSections(result, { intl });
  assignProps(item, {
    ...result,
    sections,
    readStatus: states.SUCCESS,
    readErrors: [],
  });
});

const showCatalogueTemplateError = withDraft((draft, action) => {
  const item = findCatalogueTemplate(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

export default {
  [actions.CLOSE_CATALOGUE_TEMPLATES]: closeCatalogueTemplates,
  [actions.FETCH_CATALOGUE_TEMPLATE]: fetchCatalogueTemplate,
  [actions.FETCH_CATALOGUE_TEMPLATE_FOR_DATASET]: fetchCatalogueTemplate,
  [actions.FETCH_CATALOGUE_TEMPLATES]: fetchCatalogueTemplates,
  [actions.REFRESH_CATALOGUE_TEMPLATES]: fetchCatalogueTemplates,
  [actions.SHOW_CATALOGUE_TEMPLATE_SUCCESS]: showCatalogueTemplateSuccess,
  [actions.SHOW_CATALOGUE_TEMPLATE_DATASET_ERROR]: showCatalogueTemplateError,
  [actions.SHOW_CATALOGUE_TEMPLATE_DATASET_SUCCESS]: showCatalogueTemplateSuccess,
  [actions.SHOW_CATALOGUE_TEMPLATE_ERROR]: showCatalogueTemplateError,
  [actions.SHOW_CATALOGUE_TEMPLATES]: showCatalogueTemplates,
  [actions.SHOW_CATALOGUE_TEMPLATES_ERROR]: showCatalogueTemplatesError,
};
